import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import {Formik,Form} from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";


const CreateHotelStarRating = (props) => {
  const [HotelStarRating, setHotelStarRating] = useState('');
  const [response,fetchData] = UseFetchData();
  const [responseGetData,fetchGetData] = UseFetchData();

  const validationSchema = Yup.object({
    HotelStarRating : Yup.string().required('Required!'),
   
  });

  const onSubmit = values => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("Type",'Hotel Star Rating');
    bodyFormData.append("PKID",props.PKID);
    bodyFormData.append("Value1",values.HotelStarRating);
    fetchData("Primary/Save",bodyFormData);
  }

  const getByIDData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("Type",'Hotel Star Rating');
    bodyFormData.append("PKID",props.PKID);
    fetchGetData("Primary/GetByID",bodyFormData);
  }

  useEffect(() => {
    if(response.Response === true) {
      props.setOpen(false);
      props.PopulateData();
      alert('Saved Successfully.')
    }
    else if(response.Response === false){
       alert('Save Failed.')
    }
  },[response])


  useEffect(() => {
    if(responseGetData.length > 0) {
      setHotelStarRating(responseGetData[0].HotelStarRating);
    }
  },[responseGetData])

  useEffect(() => {
  if(props.PKID != ''){
    getByIDData();
  }
  },[])

  return(<div>
    <Formik initialValues={{ HotelStarRating: HotelStarRating}}
      validationSchema = {validationSchema} onSubmit = {onSubmit} enableReinitialize>
        {formik => {
          return <Form>
            <Grid spacing={2} container>
            
              <Grid item xs= {12}>
                <BiztranControlsFormik
                control = 'input'
                type = 'text'
                label = 'Hotel Star Rating'
                name = 'HotelStarRating'
                onChange = {(e) => setHotelStarRating(e.target.value)}
                />

              </Grid>
              <Grid item xs= {12}>
                <div style = {{width:'100%'}}>
                  <div style = {{display:'flex',justifyContent:'center',alignContent:"center"}}>
                    <BiztranControls.Button 
                      text = "SAVE"
                      type = "submit"
                      startIcon = {<SaveIcon/>}
                    />
                    <BiztranControls.Button
                      text = "CLOSE"
                      startIcon = {<CloseIcon/>}
                      onClick= {() => {props.setOpen(false);}}
                    />
                  </div>
                </div>
              

              </Grid>
            </Grid>
          </Form>
        }}
      </Formik>
  </div>)

}

export default CreateHotelStarRating;